import { CheckmarkThin, CloseCrossThinSvg, useBEM } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { CHILD_PICKER_PAGE_TRANSLATION_NAMESPACE, ResponseStatus } from '../ChildPickerPage';
import './RequestResultForOrganization.less';

export const RequestResultForOrganization = ({ requestResult }: { requestResult: ResponseStatus }) => {
  const { t } = useTranslation(CHILD_PICKER_PAGE_TRANSLATION_NAMESPACE);
  const bemClasses = useBEM('RequestResultForOrganization');

  return (
    <div
      className={bemClasses({
        modifier: requestResult,
      })}
    >
      {requestResult === 'success' ? <CheckmarkThin /> : <CloseCrossThinSvg />}
      <p
        className={bemClasses({
          element: 'request-response-text',
        })}
      >
        {t(requestResult)}
      </p>
    </div>
  );
};
